export const ActionTypes = {
  adder: 0,
  sub: 0,
};
